import { handleRequest } from '../../utils/axios';

export const runCodeAPI = async (data) => {
  const config = {
    url: '/code/run',
    method: 'POST',
    data
  };
  return handleRequest(config);
};

export const checkCodeAPI = async (data) => {
  const config = {
    url: '/code/check',
    method: 'POST',
    data
  };
  return handleRequest(config);
};

export const submitCodeAPI = async (data) => {
  const config = {
    url: '/code/submit',
    method: 'POST',
    data
  };
  return handleRequest(config);
};

